import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Company } from 'app/models/entities.model';
import { ClaimedNFT, Roles, UserProfile } from 'app/models/profile.models';
import { ProfileService } from 'app/services/profile.service';

@Component({
	selector: 'user-profile-page',
	templateUrl: './user-profile.page.html',
	styleUrls: ["../user-profile.page.scss"]
})

export class UserProfilePage implements OnInit {
	pageLoaded = false;
	userProfile: UserProfile;
	formGroup: FormGroup;

	constructor(
		private _userProfileService: ProfileService,
		private _fb: FormBuilder
		) {
	}


	isRecipeEditor = () => {
		if (this.userProfile) return this.userProfile.isInRole(Roles.RECIPE_EDITOR);
		return false;
	}

	
	ngOnInit() {
		this._userProfileService.loadUserProfile().subscribe((result) => {
			this.userProfile = result;
			this.initForm();
			this.formGroup.patchValue(this.userProfile);
			this.pageLoaded = true;
		})
	}
	private initForm = (): void => {
		this.formGroup = this._fb.group({
			
			firstName: [null, Validators.required],
			lastName: [null, Validators.required],
			email: [null, Validators.required],
			
		});

		
		
		
	}
}